import React, { useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Dialog from '../../../../common/element/Dialog'
import Tabs from '../../../../common/element/Tabs/Tabs'
import TabList from '../../../../common/element/Tabs/TabList'
import TabNav from '../../../../common/element/Tabs/TabNav'
import TabContent from '../../../../common/element/Tabs/TabContent'
import BtnPrimary from '../../../../common/element/Buttons/btnPrimary'
import Select from '../../../../common/element/Select'
import ThreeDotLoader from "../../../../common/element/ButtonLoader/ThreeDotLoader"
import CommonPhoneInput from '../../../../common/CommonPhoneInput/CommonPhoneInput'
import SweetAlertService from '../../../../common/SweetAlert/SweetAlert';

import { clearCities, clearStates, getCityList, getCountryList, getStateList } from '../../../../redux/countryStateCity/cityStateCountrySlice'
import { selectCityList, selectCountryList, selectStateList } from '../../../../redux/countryStateCity/cityStateCountrySelector'
import { getSessionMasterList } from '../../../../redux/SessionMaster/sessionMasterSlice'
import { selectSessionMasterList } from '../../../../redux/SessionMaster/sessionMasterSelector'
import {
    createSalesTrainingCompany,
    updateSalesTrainingCompany,
    clearCreateSalesTrainingCompany,
    clearUpdateSalesTrainingCompany
} from '../../../../redux/SalesTrainingCompanies/SalesTrainingCompaniesslice'
import {
    selectCreateSalesTrainingCompanyData,
    selectCreateSalesTrainingCompanyLoading,
    selectCreateSalesTrainingCompanyError,
    selectUpdateSalesTrainingCompanyData,
    selectUpdateSalesTrainingCompanyLoading,
    selectUpdateSalesTrainingCompanyError
} from '../../../../redux/SalesTrainingCompanies/SalesTrainingCompaniesselectors'

const AddEditIndividual = ({ dialogOpen, onDialogClose, individualData, isEdit }) => {
    const [tab, setTab] = useState("tab1");
    const countryList = useSelector(selectCountryList);
    const stateList = useSelector(selectStateList);
    const cityList = useSelector(selectCityList);
    const dispatch = useDispatch();
    const selectSessionMasterListData = useSelector(selectSessionMasterList);

    const createData = useSelector(selectCreateSalesTrainingCompanyData);
    const createLoading = useSelector(selectCreateSalesTrainingCompanyLoading);
    const createError = useSelector(selectCreateSalesTrainingCompanyError);

    const updateData = useSelector(selectUpdateSalesTrainingCompanyData);
    const updateLoading = useSelector(selectUpdateSalesTrainingCompanyLoading);
    const updateError = useSelector(selectUpdateSalesTrainingCompanyError);

    const countryOptions = countryList.map(country => ({
        value: country.country_id.toString(),
        label: country.country_name
    }));

    const initialFormData = {
        firstName: "",
        lastName: "",
        companyName: "",
        emailAddress: "",
        phoneNumber: "",
        gender: null,
        addressLine1: "",
        addressLine2: "",
        city: "",
        country: "",
        state: "",
        pincode: "",
        phoneLandline: "",
        enablePortal: true,
        assignCoach: null,
        sessionName: null,
        date: "",
        time: "",
        notes: ""
    };

    const [formData, setFormData] = useState(initialFormData);

    const initialFormErrors = {
        firstName: "", lastName: "", companyName: "", emailAddress: "", phoneNumber: "",
        gender: "", addressLine1: "", addressLine2: "", city: "", state: "", pincode: "",
        phoneLandline: "", enablePortal: "", assignCoach: "", sessionName: "", date: "", time: "", notes: ""
    };

    const [formError, setFormErrors] = useState(initialFormErrors);

    const findOptionByValue = (options, value) => options.find(option => option.value === value) || null;

    const genderOptions = [
        { value: "male", label: "Male" },
        { value: "female", label: "Female" },
        { value: "other", label: "Other" }
    ];

    const sessionOptions = useMemo(() => selectSessionMasterListData?.map(session => ({
        value: session.id || session.session_id,
        label: session.name || session.session_name || session.title
    })) || [], [selectSessionMasterListData]);

    const stateOptions = stateList.map(state => ({ value: state.state_id.toString(), label: state.state_name }));
    const cityOptions = cityList.map(city => ({ value: city.city_id.toString(), label: city.city_name }));
    const todayDate = new Date().toISOString().split('T')[0];

    useEffect(() => {
        if (isEdit && individualData) {
            let addrLine1 = "";
            let addrLine2 = "";
            if (individualData.address) {
                const parts = individualData.address.split('\n');
                addrLine1 = parts[0] || "";
                addrLine2 = parts.slice(1).join('\n') || "";
            } else {
                addrLine1 = individualData.addressLine1 || "";
                addrLine2 = individualData.addressLine2 || "";
            }

            setFormData({
                firstName: individualData.user?.first_name || "",
                lastName: individualData.user?.last_name || "",
                companyName: individualData.company_name || "",
                emailAddress: individualData.user?.email || "",
                phoneNumber: individualData.user?.mobile_number || "",
                gender: individualData.gender ? findOptionByValue(genderOptions, individualData.gender.toLowerCase()) : null,
                addressLine1: addrLine1,
                addressLine2: addrLine2,
                city: individualData.city?.city_id || individualData.city_id || "",
                state: individualData.state?.state_id || individualData.state_id || "",
                country: individualData.country?.country_id || individualData.country_id || "",
                pincode: individualData.pincode || "",
                phoneLandline: individualData.phone_landline || "",
                enablePortal: individualData.isPortalEnabled ?? true,
                sessionName: (individualData.sessions && individualData.sessions.length > 0)
                    ? findOptionByValue(sessionOptions, individualData.sessions[0].session?.session_id)
                    : null,
                date: (individualData.sessions && individualData.sessions.length > 0) ? individualData.sessions[0].session_date : "",
                time: (individualData.sessions && individualData.sessions.length > 0) ? individualData.sessions[0].session_time : "",
                notes: individualData.notes || ""
            });

            const countryId = individualData.country?.country_id || individualData.country_id;
            if (countryId) dispatch(getStateList(countryId));
            const stateId = individualData.state?.state_id || individualData.state_id;
            if (stateId) dispatch(getCityList(stateId));
        } else {
            setFormData(initialFormData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEdit, individualData, dialogOpen, sessionOptions]);

    useEffect(() => {
        if (createData) {
            SweetAlertService.showSuccess({ message: createData?.message || createData?.data?.message || 'Individual added successfully!' });
            dispatch(clearCreateSalesTrainingCompany());
            handleDialogClose();
        }
    }, [createData, dispatch]);

    useEffect(() => {
        if (createError) {
            SweetAlertService.showError({ message: createError, icon: 'error' });
        }
    }, [createError]);

    useEffect(() => {
        if (updateData) {
            SweetAlertService.showSuccess({ message: updateData?.message || updateData?.data?.message || 'Individual updated successfully!' });
            dispatch(clearUpdateSalesTrainingCompany());
            handleDialogClose();
        }
    }, [updateData, dispatch]);

    useEffect(() => {
        if (updateError) {
            SweetAlertService.showError({ message: updateError, icon: 'error' });
        }
    }, [updateError]);

    const handlePhoneKeyPress = (e) => {
        const charCode = e.which ? e.which : e.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) e.preventDefault();
    };

    const handleCountryChange = (value) => {
        handleInputChange("country", value);
        handleInputChange("state", 0);
        handleInputChange("city", 0);
        dispatch(clearCities());
        if (value) dispatch(getStateList(value));
        else dispatch(clearStates());
    };

    const handleStateChange = (value) => {
        handleInputChange("state", value);
        handleInputChange("city", 0);
        if (value) dispatch(getCityList(value));
        else dispatch(clearCities());
    };

    const handleInputChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
        if (formError[field]) setFormErrors(prev => ({ ...prev, [field]: "" }));
    };

    const handlePhoneChange = (field, value, country) => {
        handleInputChange(field, value);
        if (value && country && country.format) {
            const requiredLength = (country.format.match(/\./g) || []).length;
            setFormErrors(prev => ({
                ...prev,
                [field]: value.length < requiredLength ? "Invalid phone number" : ""
            }));
        } else {
            setFormErrors(prev => ({ ...prev, [field]: "" }));
        }
    };

    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const validateTab1 = () => {
        const errors = {};
        if (!formData.firstName) errors.firstName = "First name is required";
        if (!formData.lastName) errors.lastName = "Last name is required";
        if (!formData.emailAddress) errors.emailAddress = "Email address is required";
        else if (!validateEmail(formData.emailAddress)) errors.emailAddress = "Please enter a valid email address";
        if (!formData.phoneNumber) errors.phoneNumber = "Phone number is required";
        else if (formError.phoneNumber) errors.phoneNumber = formError.phoneNumber;
        if (!formData.gender) errors.gender = "Gender is required";
        setFormErrors(prev => ({ ...prev, ...errors }));
        return Object.keys(errors).length === 0;
    };

    const validateTab2 = () => {
        const errors = {};
        if (formError.phoneLandline) errors.phoneLandline = formError.phoneLandline;
        setFormErrors(prev => ({ ...prev, ...errors }));
        return Object.keys(errors).length === 0;
    };

    const validateTab3 = () => {
        const errors = {};
        if (!formData.sessionName) errors.sessionName = "Session Name is required";
        if (!formData.date) errors.date = "Date is required";
        setFormErrors(prev => ({ ...prev, ...errors }));
        return Object.keys(errors).length === 0;
    };

    const handleNext = () => {
        if (tab === "tab1" && validateTab1()) setTab("tab2");
        else if (tab === "tab2" && validateTab2()) setTab("tab3");
    };

    const handleTabClick = (targetTab) => {
        if (tab === "tab1" && !validateTab1()) return;
        else if (tab === "tab2" && !validateTab2()) return;
        setTab(targetTab);
    };

    const handleSubmit = () => {
        if (!validateTab3()) return;

        const apiPayload = {
            first_name: formData.firstName,
            last_name: formData.lastName,
            email: formData.emailAddress,
            phone_number: formData.phoneNumber,
            gender: formData.gender?.value || formData.gender,
            company_name: formData.companyName,
            isPortalEnabled: formData.enablePortal,
            country_id: parseInt(formData.country) || 0,
            state_id: parseInt(formData.state) || 0,
            city_id: parseInt(formData.city) || 0,
            address: `${formData.addressLine1}${formData.addressLine2 ? '\n' + formData.addressLine2 : ''}`,
            pincode: formData.pincode,
            phone_landline: formData.phoneLandline,
            session_id: formData.sessionName?.value || 0,
            session_date: formData.date,
            notes: formData.notes
        };

        if (isEdit && individualData?.id) {
            dispatch(updateSalesTrainingCompany({ stc_id: individualData.id, data: apiPayload }));
        } else {
            dispatch(createSalesTrainingCompany(apiPayload));
        }
    };

    const handleDialogClose = () => {
        setFormData(initialFormData);
        setFormErrors(initialFormErrors);
        setTab("tab1");
        dispatch(clearCreateSalesTrainingCompany());
        dispatch(clearUpdateSalesTrainingCompany());
        onDialogClose();
    };

    useEffect(() => {
        if (!dialogOpen) return;
        dispatch(getCountryList());
        dispatch(getSessionMasterList({ page: 0, limit: 0, archived: false, access_group_id: 6 }));
    }, [dialogOpen, dispatch]);

    const isSubmitting = createLoading || updateLoading;

    return (
        <Dialog
            isOpen={dialogOpen}
            onClose={handleDialogClose}
            width={900}
            onRequestClose={handleDialogClose}
            bodyOpenClassName="overflow-hidden"
        >
            <div className="flex border-b mb-5 pb-5 px-6 pt-6 items-center justify-between">
                <div className="flex items-center">
                    <span className="h-12 w-12 border rounded-lg border-gray-200 flex items-center justify-center shadow-sm mr-4">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z" fill="#344054" />
                        </svg>
                    </span>
                    <div>
                        <h5 className="mb-0 font-lato not-italic font-medium text-[16px] leading-[150%] text-[#101828]">
                            {isEdit ? 'Edit Sales' : 'Add Sales'}
                        </h5>
                    </div>
                </div>
                <button onClick={handleDialogClose} className="text-gray-400 hover:text-gray-600">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
            </div>

            <Tabs value={tab} variant="pill">
                <div className="px-6 mb-5">
                    <div className="p-1 rounded-lg client-portal-tab" style={{ backgroundColor: '#FFF4E5' }}>
                        <TabList>
                            {["tab1", "tab2", "tab3"].map((t, i) => (
                                <TabNav
                                    key={t}
                                    value={t}
                                    onClick={() => handleTabClick(t)}
                                    style={{
                                        backgroundColor: tab === t ? '#ffffff' : 'transparent',
                                        color: '#344054',
                                        fontWeight: tab === t ? '600' : '500'
                                    }}
                                >
                                    {["Personal Information", "Address Details", "Other Details"][i]}
                                </TabNav>
                            ))}
                        </TabList>
                    </div>
                </div>

                {/* Tab 1: Personal Information */}
                <TabContent value="tab1">
                    <div className="px-6">
                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">Name*</label>
                            <div className="w-3/4 pl-2 flex gap-3">
                                <div className="flex-1">
                                    <input className="h-9 pl-3 w-full input input-shadow text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline" value={formData.firstName} placeholder="Enter First name here" onChange={(e) => handleInputChange("firstName", e.target.value)} />
                                    {formError.firstName && <p className="text-xs text-red-600 mb-2 mt-1">{formError.firstName}</p>}
                                </div>
                                <div className="flex-1">
                                    <input className="h-9 pl-3 w-full input input-shadow text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline" value={formData.lastName} placeholder="Enter Last name here" onChange={(e) => handleInputChange("lastName", e.target.value)} />
                                    {formError.lastName && <p className="text-xs text-red-600 mb-2 mt-1">{formError.lastName}</p>}
                                </div>
                            </div>
                        </div>

                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">Company Name</label>
                            <div className="w-3/4 pl-2">
                                <input className="h-9 pl-3 w-full input input-shadow text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline" value={formData.companyName} placeholder="Enter Company Name here" onChange={(e) => handleInputChange("companyName", e.target.value)} />
                            </div>
                        </div>

                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">Email*</label>
                            <div className="w-3/4 pl-2">
                                <input type="email" className="h-9 pl-3 w-full input input-shadow text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline" value={formData.emailAddress} placeholder="Enter Email address here" onChange={(e) => handleInputChange("emailAddress", e.target.value)} />
                                {formError.emailAddress && <p className="text-xs text-red-600 mb-2 mt-1">{formError.emailAddress}</p>}
                            </div>
                        </div>

                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">Phone Number*</label>
                            <div className="w-3/4 pl-2">
                                <CommonPhoneInput value={formData.phoneNumber} onChange={(phone, country) => handlePhoneChange("phoneNumber", phone, country)} placeholder="Enter Phone Number here" error={formError.phoneNumber} />
                            </div>
                        </div>

                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">Gender*</label>
                            <div className="w-3/4 pl-2">
                                <Select className="w-full h-9 select-options" placeholder="Select Gender" options={genderOptions} value={formData.gender} onChange={(selectedOption) => handleInputChange("gender", selectedOption)} />
                                {formError.gender && <p className="text-xs text-red-600 mb-2 mt-1">{formError.gender}</p>}
                            </div>
                        </div>
                    </div>
                </TabContent>

                {/* Tab 2: Address Details */}
                <TabContent value="tab2">
                    <div className="px-6">
                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">Country/State/City</label>
                            <div className="w-3/4 pl-2 flex gap-3">
                                <div className="flex-1">
                                    <Select className="w-full h-9 select-options" placeholder="Select Country" options={countryOptions} value={countryOptions.find(c => c.value === formData.country.toString()) || null} onChange={(selectedOption) => handleCountryChange(selectedOption?.value || 0)} />
                                </div>
                                <div className="flex-1">
                                    <Select className={`w-full h-9 select-options ${(!formData.country || stateOptions.length === 0) ? 'opacity-50 cursor-not-allowed' : ''}`} placeholder="State" options={stateOptions} value={stateOptions.find(s => s.value === formData.state.toString()) || null} onChange={(selectedOption) => handleStateChange(selectedOption?.value || 0)} isDisabled={!formData.country || stateOptions.length === 0} />
                                </div>
                                <div className="flex-1">
                                    <Select className={`w-full h-9 select-options ${(!formData.state || cityOptions.length === 0) ? 'opacity-50 cursor-not-allowed' : ''}`} placeholder="City" options={cityOptions} value={cityOptions.find(c => c.value === formData.city.toString()) || null} onChange={(selectedOption) => handleInputChange("city", selectedOption?.value || 0)} isDisabled={!formData.state || cityOptions.length === 0} />
                                </div>
                            </div>
                        </div>

                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">Address</label>
                            <div className="w-3/4 pl-2">
                                <input className="h-9 pl-3 w-full input input-shadow text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-3" value={formData.addressLine1} placeholder="Line 1" onChange={(e) => handleInputChange("addressLine1", e.target.value)} />
                                <input className="h-9 pl-3 w-full input input-shadow text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline" value={formData.addressLine2} placeholder="Line 2" onChange={(e) => handleInputChange("addressLine2", e.target.value)} />
                            </div>
                        </div>

                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">Pincode/Landline</label>
                            <div className="w-3/4 pl-2 flex gap-3">
                                <div className="flex-1">
                                    <input type="text" inputMode="numeric" pattern="[0-9]*" className="h-9 pl-3 w-full input input-shadow text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline" value={formData.pincode} placeholder="Pincode" onChange={(e) => handleInputChange("pincode", e.target.value)} onKeyPress={handlePhoneKeyPress} />
                                </div>
                                <div className="flex-1">
                                    <CommonPhoneInput value={formData.phoneLandline} onChange={(phone, country) => handlePhoneChange("phoneLandline", phone, country)} placeholder="Phone Landline" error={formError.phoneLandline} />
                                </div>
                            </div>
                        </div>
                    </div>
                </TabContent>

                {/* Tab 3: Other Details */}
                <TabContent value="tab3">
                    <div className="px-6">
                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">Enable Portal*</label>
                            <div className="w-3/4 pl-2">
                                <div className="inline-flex rounded-lg border border-gray-300 bg-white overflow-hidden">
                                    {[true, false].map((val) => (
                                        <button
                                            key={String(val)}
                                            type="button"
                                            onClick={() => handleInputChange("enablePortal", val)}
                                            className={`px-8 h-9 text-sm font-medium transition-colors ${formData.enablePortal === val ? 'text-gray-900' : 'bg-white text-gray-700 hover:bg-gray-50'} ${val === false ? 'border-l border-gray-300' : ''}`}
                                            style={{ backgroundColor: formData.enablePortal === val ? '#FFF4E5' : 'white' }}
                                        >
                                            {val ? 'Yes' : 'No'}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">Session Name*</label>
                            <div className="w-3/4 pl-2">
                                <Select className="w-full h-9 select-options" placeholder="Session Name" options={sessionOptions} value={formData.sessionName} onChange={(selectedOption) => handleInputChange("sessionName", selectedOption)} />
                                {formError.sessionName && <p className="text-xs text-red-600 mb-2 mt-1">{formError.sessionName}</p>}
                            </div>
                        </div>

                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">Date*</label>
                            <div className="w-3/4 pl-2">
                                <input type="date" className="h-9 pl-3 w-full input input-shadow text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline cursor-pointer" value={formData.date} min={todayDate} onChange={(e) => handleInputChange("date", e.target.value)} onClick={(e) => e.target.showPicker?.()} />
                                {formError.date && <p className="text-xs text-red-600 mb-2 mt-1">{formError.date}</p>}
                            </div>
                        </div>

                        <div className="flex mb-5">
                            <label className="font-lato not-italic font-medium text-[14px] leading-[150%] text-[#344054] w-1/4">Notes</label>
                            <div className="w-3/4 pl-2">
                                <textarea rows={4} className="pl-3 pt-2 w-full input input-shadow text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline" value={formData.notes} placeholder="Notes" onChange={(e) => handleInputChange("notes", e.target.value)} />
                            </div>
                        </div>
                    </div>
                </TabContent>
            </Tabs>

            <div className="flex dailog-footer">
                <button className="mr-1.5 whiteBtnShadow btn border border-gray-100 block w-full rounded-lg h-10 bg-white text-gray-700 text-sm font-semibold hover:bg-gray-50 hover:border-gray-300 focus:bg-white focus:border-gray-300 duration-100 secondary-btn" variant="plain" onClick={handleDialogClose} style={{ backgroundColor: '#FFF4E5' }} disabled={isSubmitting}>
                    Cancel
                </button>

                {(tab === "tab1" || tab === "tab2") && (
                    <BtnPrimary onClick={handleNext} className="ml-1.5" style={{ backgroundColor: '#FF8E1C', borderColor: '#FF8E1C' }} disabled={isSubmitting}>
                        Next
                    </BtnPrimary>
                )}

                {tab === "tab3" && (
                    <BtnPrimary disabled={isSubmitting} onClick={handleSubmit} className="ml-1.5" style={{ backgroundColor: '#FF8E1C', borderColor: '#FF8E1C' }}>
                        {isSubmitting ? <ThreeDotLoader /> : (isEdit ? "Update Sales" : "Add Sales")}
                    </BtnPrimary>
                )}
            </div>
        </Dialog>
    );
};

export default AddEditIndividual;
